import React from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps'

const MapWithAMarker = withScriptjs(
  withGoogleMap(({ QualityPlans }) => (
    <GoogleMap
      defaultZoom={10}
      defaultCenter={{ lat: -38.2317124, lng: 146.4146 }}
      onClick={e => console.log(e.latLng.lat(), e.latLng.lng())}>
      {QualityPlans.map(x => (
        <Marker key={x.id + Math.random()} position={{ lat: x.latitude, lng: x.longitude }}></Marker>
      ))}
    </GoogleMap>
  ))
)

export default MapWithAMarker
